import { FORM_ERROR } from 'final-form';
import { OK } from 'http-status-codes';
import { call, put, takeLatest } from 'redux-saga/effects';

import { safeResolveAsync } from '../../utils';
import { authApiCall } from './helpers';
import * as loginModule from './login';
import * as tokensModule from './tokens';

export function* impersonateSaga({ businessId, resolve }) {
  try {
    const response = yield call(authApiCall, {
      url: '/users/admin/impersonate/',
      method: 'post',
      data: businessId ? { business_id: businessId } : { exit: true },
    });

    if (response.status !== OK) {
      throw Error(
        response.data?.error || response.data?.detail || 'Could not switch user.',
      );
    }

    const { access, refresh } = response.data;

    // Same sequence as a business <-> customer switch: reset sagas run,
    // tokens clear, then takeAuth sagas re-fire for the new identity.
    yield call(loginModule.replaceExistingSession);
    yield put(tokensModule.actions.setTokens({ access, refresh }));
    yield put(loginModule.actions.loginSuccess({ access, refresh }));
    yield safeResolveAsync(resolve);
  } catch (error) {
    const message = error?.response?.data?.error || error.message;
    yield safeResolveAsync(resolve, { [FORM_ERROR]: message });
  }
}

export function* fetchOptionsSaga({ query, resolve }) {
  let options = [];
  try {
    const response = yield call(authApiCall, {
      url: '/users/admin/impersonation-options/',
      method: 'get',
      params: { q: query || '' },
    });
        console.log('[impersonate] options response', response.status, response.data);
    if (response.status === OK) {
      options = response.data;
    }
  } catch (error) {
    // Leave options empty.
        console.log('[impersonate] options fetch failed', error);
  }
  if (typeof resolve === 'function') {
    resolve(options);
  }
}

export default function* saga() {
  yield takeLatest(loginModule.types.IMPERSONATE, impersonateSaga);
  yield takeLatest(loginModule.types.FETCH_IMPERSONATION_OPTIONS, fetchOptionsSaga);
}